import React, { useState, useEffect } from "react"

import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import TextField from "@material-ui/core/TextField"
import Divider from "@material-ui/core/Divider"
import Button from "@material-ui/core/Button"
import Link from "@material-ui/core/Link"
import CircularProgress from "@material-ui/core/CircularProgress"

import useDefaultStyles from "../../../styles/default"

import api from "../../../services/api"
import { useValidation } from "../../../services/validation"
import { useNavigation } from "../../../services/navigation"
import { forceLowerCase } from "../../../utils/sanitization"

import { submitOnPressEnter } from "../../../utils/submit"
import { phoneMask } from "../../../utils/mask"

const Signup = () => {
	const { navigate, getRouteParams } = useNavigation()

	const { hash } = getRouteParams()

	const inputs = [
		"name",
		"email",
		"whatsapp_number",
		"password"
	]
	const [validation, clearValidation, triggerValidation] = useValidation(inputs)

	const defaultClasses = useDefaultStyles()

	const [signupData, setSignupData] = useState({
		name: "",
		email: "",
		whatsapp_number: "",
		password: ""
	})
	const [loadingSignup, setLoadingSignup] = useState(false)

	const handleSignup = async () => {
		setLoadingSignup(true)

		try {
			// Here we set up the user auth cookie, so we need to reload the
			// page in order to make the changes to work
			await api.post(`/home/hash/${hash}/signup`, signupData)
			navigate(`/${hash}`, { keepQueryParams: true, refreshPage: true })
		} catch (error) {
			triggerValidation(error)
		}

		setLoadingSignup(false)
	}

	const handleChangeSignupData = (key, value) => {
		setSignupData({
			...signupData,
			[key]: value
		})

		clearValidation(key)
	}

	useEffect(() => {
		submitOnPressEnter()
	}, [])

	return (
		<Container className={defaultClasses.container}>
			<Typography variant="h6">
				Cadastre-se
			</Typography>

			<Typography variant="subtitle1">
				Para iniciar sua escolha de fotos basta se cadastrar rapidamente.
			</Typography>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<TextField
				required
				label="Nome"
				variant="standard"
				color="secondary"
				size="small"
				value={signupData.name}
				error={!!validation.name.validateStatus}
				helperText={validation.name.help}
				onChange={({ target }) => handleChangeSignupData("name", target.value)}
			/>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<TextField
				required
				label="Email"
				variant="standard"
				color="secondary"
				size="small"
				value={forceLowerCase(signupData.email)}
				error={!!validation.email.validateStatus}
				helperText={validation.email.help}
				onChange={({ target }) => handleChangeSignupData("email", target.value)}
			/>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<TextField
				required
				label="Telefone / Whatsapp"
				variant="standard"
				color="secondary"
				size="small"
				value={signupData.whatsapp_number}
				error={!!validation.whatsapp_number.validateStatus}
				helperText={validation.whatsapp_number.help}
				onChange={({ target }) =>
					handleChangeSignupData("whatsapp_number", phoneMask(target.value))
				}
			/>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<TextField
				required
				label="Senha"
				type="password"
				autoComplete="current-password"
				variant="standard"
				color="secondary"
				size="small"
				value={signupData.password}
				error={!!validation.password.validateStatus}
				helperText={validation.password.help}
				onChange={({ target }) =>
					handleChangeSignupData("password", target.value)
				}
			/>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<Button
				variant="contained"
				color="secondary"
				className={defaultClasses.buttonBlock}
				onClick={() => handleSignup()}
				disabled={loadingSignup}
				endIcon={loadingSignup && <CircularProgress size={20} />}
				id="submit"
			>
				Cadastrar
			</Button>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<Typography
				variant="subtitle2"
				className={defaultClasses.centeredTypography}
			>
				Ja é cadastrado?{" "}
				<Link onClick={() => navigate(`/${hash}/login`, { keepQueryParams: true })}>Faça login</Link>
			</Typography>
		</Container>
	)
}

Signup.propTypes = {}

export default Signup
